export default {
  sample: '',

  user: {},
};

export const component = 'aufgaben/';
